import React, { useEffect, useState, useRef } from "react";
import {useNavigate} from "react-router";
import LocalBreadcrumbs from "../../components/Breadcrumbs/LocalBreadcrumbs";
import Api from "../../services/Api";
import {RecordingInterface} from "./interfaces";
import RecordSound from "./RecordSound";
import iconMicOn from "url:shared-assets/icons/video/mic-on.svg";
import iconMicOff from "url:shared-assets/icons/video/mic-off.svg"

// const recordSound = new RecordSound();

enum RecordingStatusEnum {
  STOPPED,
  INITIALIZING,
  STARTED,
}

const TeamRecordings: React.FC = () => {
  const api = Api.getInstance();
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [recordings, setRecordings] = useState<Array<RecordingInterface>>([]);
  const [recordingId, setRecordingId] = useState("");
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(0);
  const [recordingStatus, setRecordingStatus] = useState<RecordingStatusEnum>(RecordingStatusEnum.STOPPED);
  const recordSound = useRef<RecordSound|null>(null);

  useEffect(() => {
    recordSound.current = new RecordSound();
    setRecordingId("t_" + new Date().getTime());
    getData();
  }, []);

  const getData = () => {
    api
      .get("client/recordings")
      .then((response) => {
        if (response.json.error) {
          setError(response.json.error);
        } else {
          setRecordings(response.json.recordings);
          setLoaded(true);
        }
      })
      .catch((error) => {
        alert("Unknown error (http status " + error.response.status + ")");
      });
  };

  if (error.length > 0) {
    return <div className="mt-4">Error: {error}</div>;
  }

  if (!loaded) {
    return <div className="mt-4">Loading...</div>;
  }

  const onRecordingStart = () => {
    setRecordingStatus(RecordingStatusEnum.STARTED);
  }

  const onSendSound = (_duration: number) => {
    setDuration(_duration);
  }

  const onVolume = (_volume: number) => {
    setVolume(_volume);
  }

  const handleRecord = () => {
    if (recordingStatus === RecordingStatusEnum.STARTED) {
      setRecordingStatus(RecordingStatusEnum.STOPPED);
      recordSound.current?.stop();
      setTimeout(() => {
        navigate("/team/recording/" + recordingId);
      }, 600)
    } else if (recordingStatus === RecordingStatusEnum.STOPPED) {
      setRecordingStatus(RecordingStatusEnum.INITIALIZING);
      if (api.apiToken) {
        recordSound.current?.start(api.apiToken, recordingId, onRecordingStart, onSendSound, onVolume);
      } else {
        alert("Missing client token");
      }
    }
  }

  const showRecordingStatus = () => {
    if (recordingStatus === RecordingStatusEnum.STOPPED) {
      return "Start a new recording"
    } else if (recordingStatus === RecordingStatusEnum.INITIALIZING) {
      return "Please wait, initializing recording..."
    } else {
      return (
        <div className="flex justify-between gap-x-4 items-center">
          <div className="z-body1">Stop recording</div>
          <div className="z-body1 w-20">{(duration / 1000).toFixed(1)} s</div>
          <div style={{width: 100, height: 12}} className="bg-gray-800">
            <div style={{width: volume, height: 12}} className="bg-aquamarine-400"></div>
          </div>
        </div>
      )
    }
  }

  return (
    <>
      <LocalBreadcrumbs crumbs={[
        {name: "Team", url: "/team"},
        {name: "Recordings"},
      ]}/>

      <div className="mt-4 z-heading2">
        New recording
      </div>

      <div className="main-half-col bg-indigo-900 px-4 py-2 mt-2 rounded-md flex items-center cursor-pointer"
           onClick={() => handleRecord()}>
        <img src={recordingStatus === RecordingStatusEnum.STOPPED ? iconMicOff : iconMicOn} alt="record" className="h-8 w-8"/>
        <div className="ml-4 z-body1">
          {showRecordingStatus()}
        </div>
      </div>

      <div className="mt-4 z-heading2">
        Recordings
      </div>

      <div className="main-half-col bg-indigo-900 px-4 py-2 mt-2 rounded-md">

        {
          recordings.map((recording, i) => (
            <div key={"recording_" + i} className="my-2 cursor-pointer"
                 onClick={() => navigate('/team/recording/' + recording.id)}>
              <div className="flex items-center justify-between">
                <p className="z-title1">{recording.name}</p>
              </div>
              <p className="z-body2">Created: {recording.created.substring(0, 16).replace("T", " ")}</p>
            </div>
          ))
        }
        {
          recordings.length === 0 &&
            <div className="z-body1">You have no recordings so far</div>
        }
      </div>
    </>
  );
};

export default TeamRecordings;
